import { RR_CLICK_TYPE } from '../../enum/click-type.enum';

export interface RRITableRowClick<T> {
  row: T;
  clickType: RR_CLICK_TYPE;
}
